<template>
    <div :class="viewClass" class="c-calendar-wrapper">
        <Calendar :first-instance-date="firstDate" :last-instance-date="lastDate"/>
    </div>
</template>
<script>
    import Calendar from './components/Calendar'

    export default {
        name: 'App',
        props: {
        firstDate: {
            type: [String, Date],
        default: null
        },
        lastDate: {
            type: [String, Date],
        default: null
        }
    },
        components: {
            Calendar
        },
        data() {
            return {
                viewClass: this.setViewClass()
            }

        },
        methods: {
            setViewClass() {
                if (this.isFilteredView()) {
                    return 'c-listFiltered-view'
                }

                return window.screen.width < 720 ? 'c-listTwoWeek-view' : 'c-dayGridMonth-view'
            },
            isFilteredView() {
                const urlParams = new URLSearchParams(window.location.search)

                return urlParams.has('startDate') && urlParams.get('startDate').length > 0
                    && urlParams.has('endDate') && urlParams.get('endDate').length > 0
            },
        }
    }
</script>
